"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var GridFilterConverter_1 = require("./conversions/GridFilterConverter");

var GridFilterConverterImpl_1 = require("./conversions/GridFilterConverterImpl");

var GridFilterAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(GridFilterAppModule, _AppModule_1$AppModul);

  function GridFilterAppModule() {
    var _this;

    _classCallCheck(this, GridFilterAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridFilterAppModule).apply(this, arguments));
    _this.name = 'gridFilterAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(GridFilterAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(GridFilterConverter_1.GridFilterConverter).to(GridFilterConverterImpl_1.GridFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return GridFilterAppModule;
}(AppModule_1.AppModule);

exports.GridFilterAppModule = GridFilterAppModule;